import type { Component } from "svelte";
import { CartModalKind } from "@core/schema/CartModalKind.js";
import ClearForProducts from "./ClearForProducts.svelte";
import ClearForSubscription from "./ClearForSubscription.svelte";
import OrderError from "./OrderError.svelte";

export const cartModalComponentMap = {
	[CartModalKind.OrderError]: OrderError,
	[CartModalKind.ClearForSubscription]: ClearForSubscription,
	[CartModalKind.ClearForProducts]: ClearForProducts,
} satisfies Record<CartModalKind, Component<never>>;
